/* Domi Skin floating add-to-cart bar.
   Mirrors the real Add to cart button so cart behaviour stays the theme's.

   VISIBILITY: the bar shows whenever the real buy buttons are off screen,
   whether the shopper is above them (top of the page, gallery first on
   mobile) or has scrolled past them. It hides only while the real buttons
   are in view, so there are never two Add buttons on screen at once. */
(function () {
  function init() {
    var bar = document.getElementById('domiSticky');
    var btn = document.getElementById('domiStickyBtn');
    var priceOut = document.getElementById('domiStickyPrice');
    if (!bar || !btn) return;

    var label = btn.getAttribute('data-label') || 'Add to your routine';

    var block = document.querySelector('.buy-buttons-block');
    if (!block) return;

    function realButton() {
      return block.querySelector('.add-to-cart-button, button[type="submit"]');
    }

    function syncPrice() {
      var p = document.querySelector('.product-details .price');
      if (p && priceOut) priceOut.textContent = p.textContent.replace(/\s+/g, ' ').trim();
    }

    function syncState() {
      var rb = realButton();
      if (!rb) return;
      btn.disabled = rb.disabled;
      if (rb.disabled) btn.textContent = rb.textContent.trim() || 'Unavailable';
    }

    function show(on) {
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    }

    syncPrice();
    syncState();

    btn.addEventListener('click', function () {
      var rb = realButton();
      if (!rb || rb.disabled) return;
      rb.click();
      btn.textContent = 'Added';
      btn.classList.add('is-done');
      setTimeout(function () {
        btn.textContent = label;
        btn.classList.remove('is-done');
      }, 1600);
    });

    var target = realButton() || block;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        if (!e) return;
        show(!e.isIntersecting);
      }, { threshold: 0 }).observe(target);
    } else {
      show(true);
    }

    document.addEventListener('variant:update', syncPrice);
    document.addEventListener('change', function () { setTimeout(function () { syncPrice(); syncState(); }, 120); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
